import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { DirtinessService } from 'src/core/services/dirtiness.service';
import { OrderItemStatus } from "src/interfaces/order-item";
import { BatchStatus } from 'src/interfaces/batch';
import { MedicineService } from 'src/core/services/medicine.service';
import { OrderMedicineService } from 'src/core/services/order-medicine.service';
import { Medicine } from 'src/interfaces/medicine';
import { CreateOrderMedicinePayload } from 'src/interfaces/order-medicine';
import { AlertService } from 'src/core/services/alert.service';

@Component({
  selector: 'app-order-medicine-create',
  templateUrl: './order-medicine-create.component.html',
  styleUrls: ['./order-medicine-create.component.scss']
})
export class OrderMedicineCreateComponent implements OnInit, OnDestroy {
  batchStatuses: BatchStatus[] = [];
  orderItemStatuses: OrderItemStatus[] = [];
  createdOrderMedicine: Medicine | null = null;

  constructor(
    private _medicineService: MedicineService,
    private _orderMedicineService: OrderMedicineService,
    private _router: Router,
    private _dirtinessService: DirtinessService,
    private _alertService: AlertService
  ) {}

  ngOnInit(): void {
    // Initialize data
    this.loadStatuses();
  }
  
  ngOnDestroy(): void {
    // Clear dirtiness when component is destroyed
    this._dirtinessService.setDirty(false);
  }

  async loadStatuses() {
    // Load any necessary statuses here
  }

  async addOrderItem(item: any) {
    // Set dirty state
    this._dirtinessService.setDirty(true);
    
    // Save to the backend if it has medicine_dosage_package_type
    if (item.medicineDosagePackageType && item.medicine) {
      const payload: CreateOrderMedicinePayload = {
        medicine_dosage_package_type_id: item.medicineDosagePackageType.id,
        dosage_package_type_id: item.medicineDosagePackageType.package_type_id,
        medicine_id: item.medicine.id
      };
      
      try {
        const result = await this._orderMedicineService.createOrderMedicine(payload);
        if (result) {
          // Clear dirty state after successful save
          this._dirtinessService.setDirty(false);
          
          this._alertService.infoAlert('Medicine added successfully');
          
          // Navigate to the list view after adding
          this._router.navigate(['/portal/order-medicine']);
        }
      } catch (error) {
        console.error('Error creating order medicine:', error);
        this._alertService.errorAlert('Failed to add medicine to the order');
      }
    }
  }
}


